module.exports = __webpack_public_path__ + "static/media/eye.50d29697.svg";